import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UsernameStorageService } from '../services/username-storage.service';

export const usernameGuard: CanActivateFn = (route, state) => {
  const storage = inject(UsernameStorageService);
  const router = inject(Router);

  if (storage.hasValidUsername()) {
    return true;
  }

  return router.createUrlTree(['/welcome'], {
    queryParams: { returnUrl: state.url },
  });
};
